import { authDelete } from './authMiddleware';

export const deleteFolderIteam = (data) => {
    return authDelete('/api/portfolioitem', data);
}